module.exports = __webpack_public_path__ + "img/getcode-1.edf9f8d5.png";